import { Registration } from 'components/kyc/registration';
import React from 'react';

export const RegistrationPage: React.FC = () => {
    return <Registration />;
};
